module.exports = __webpack_public_path__ + "img/thumbnail-tab-with-content-losa.c39a9194.webp";